export default __webpack_public_path__ + "static/media/intechgration-logo.2817f66b.svg";